var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTokenSOhm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6:165",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6:165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z",
    fill: "#00FF11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1C24.2843 1 31 7.71573 31 16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 16C23.5 20.1421 20.1421 23.5 16 23.5C11.8579 23.5 8.5 20.1421 8.5 16C8.5 11.8579 11.8579 8.5 16 8.5C20.1421 8.5 23.5 11.8579 23.5 16Z",
    fill: "#00FF11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 16C22.5 19.5899 19.5899 22.5 16 22.5C12.4101 22.5 9.5 19.5899 9.5 16C9.5 12.4101 12.4101 9.5 16 9.5C19.5899 9.5 22.5 12.4101 22.5 16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25 1C21.25 3.89949 18.8995 6.25 16 6.25C13.1005 6.25 10.75 3.89949 10.75 1C10.75 -1.89949 13.1005 -4.25 16 -4.25C18.8995 -4.25 21.25 -1.89949 21.25 1Z",
    fill: "#00FF11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 1C20.25 3.34721 18.3472 5.25 16 5.25C13.6528 5.25 11.75 3.34721 11.75 1C11.75 -1.34721 13.6528 -3.25 16 -3.25C18.3472 -3.25 20.25 -1.34721 20.25 1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 15.5H9V16.5H0.5V15.5Z",
    fill: "#00FF11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 23L16.5 31.5L15.5 31.5L15.5 23L16.5 23Z",
    fill: "#00FF11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5.875L16.5 8.875L15.5 8.875L15.5 5.875L16.5 5.875Z",
    fill: "#00FF11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 15.5H31.5V16.5H23V15.5Z",
    fill: "#00FF11"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6119 1.64954C17.6043 0.751173 14.399 0.756949 11.3946 1.66615L11.105 0.709019C14.297 -0.256986 17.7026 -0.263122 20.8981 0.69137L20.9554 0.7085L20.6692 1.66667L20.6119 1.64954Z",
    fill: "#00FF11"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenSOhm);
export default __webpack_public_path__ + "static/media/token_sOHM.6716c283.svg";
export { ForwardRef as ReactComponent };